import React from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
];

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();

  return (
    <div className={`flex gap-2 ${className}`}>
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          className={`text-sm font-semibold px-2 py-1 transition-opacity ${
            i18n.language === code ? "opacity-100" : "opacity-40 hover:opacity-70"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
